import copy from 'copy-to-clipboard';

export default class SingleSharer {
    
    
    static get selector() {
        return '.single__sharer';
    }

    constructor(el) {
        this.el = el;
        this.button = this.el.querySelector('.single__share');
        this.isOpen = false;

        this.copyButton = this.el.querySelector('.single__sharerItem--copy');
        this.url = this.copyButton.getAttribute('href');
        this.title = document.title;
        
        this.setEvents();
    }

    toggle() {
        if(this.isOpen) this.close();
        else this.open();
    }

    open() {
        this.el.classList.add('single__sharer--active');
        this.isOpen = true;
    }
    close() {
        this.el.classList.remove('single__sharer--active');
        this.isOpen = false;
    }

    navigatorShare() {
        navigator.share({
            title: this.title,
            //text: 'Check out web.dev.',
            url: this.url,
        })
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error));
    }

    setEvents() {
        this.button.addEventListener('click', this.e_click.bind(this));
        this.copyButton.addEventListener('click', this.e_clickCopy.bind(this));
    }

    e_click(e) {
        e.preventDefault();
        gtag('event', 'share');
        if (navigator.share) this.navigatorShare();
        else this.toggle();
        window.dispatchEvent(new CustomEvent('vegout-share'));
    }

    e_clickCopy(e) {
        e.preventDefault();

        let copyItem = copy(this.url, {
            debug: true,
            message: 'Press #{key} to copy',
        });

        if(copyItem){
            this.copyButton.classList.add('single__sharerItem--active');

            setTimeout(() => {
                this.copyButton.classList.remove('single__sharerItem--active');
            }, 900)
        }

    }
}